import { useCallback } from 'react';

import { getFragmentData } from '@e-socna/data-layer';
import { isDefined } from '@e-socna/utils';
import type { FragmentType } from '@e-socna/data-layer';

import { ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment } from '../Card/fragments/resolvable-service.fragment';
import { ServiceUsageCardCmp_Service_Fragment } from '../Card/fragments/service.fragment';
import type { ServiceUsageCardCmp_ResolvableServiceBaseInterface } from '../Card/fragments/resolvable-service.fragment';
import type { ServiceUsageCardCmp_Service } from '../Card/fragments/service.fragment';
import type { ServiceType } from '../types/props.type';

type O<
  // Output
  R extends boolean, // Required
  S extends ServiceType<R> | undefined, // Service
> = S extends undefined
  ? S
  : R extends true
    ? ServiceUsageCardCmp_ResolvableServiceBaseInterface
    : ServiceUsageCardCmp_Service;

export const useGetServiceData = () =>
  useCallback(
    <R extends boolean, S extends ServiceType<R> | undefined>(
      isResolvable: R,
      service: S,
    ): O<R, S> =>
      !isDefined(service)
        ? (service as O<R, S>)
        : isResolvable
          ? (getFragmentData(
              ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment,
              service as FragmentType<
                typeof ServiceUsageCardCmp_ResolvableServiceBaseInterface_Fragment
              >,
            ) as O<R, S>)
          : (getFragmentData(
              ServiceUsageCardCmp_Service_Fragment,
              service as FragmentType<
                typeof ServiceUsageCardCmp_Service_Fragment
              >,
            ) as O<R, S>),
    [],
  );
